import { useState } from "react";
import { ChevronDown } from "lucide-react";

/* Card-on-mobile table row: a compact summary line that taps open into label/value pairs.
   Same pattern the History log uses, shared by every admin table. */
export const MobileRow = ({ testid, title, badge, trailing, rows = [], actions, extra }) => {
  const [open, setOpen] = useState(false);

  return (
    <div data-testid={testid}>
      <button
        type="button"
        data-testid={`${testid}-toggle`}
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-3 text-left transition-colors duration-200 active:bg-zinc-800/40"
      >
        <span className="min-w-0 flex-1">{title}</span>
        {badge}
        {trailing}
        <ChevronDown
          className={`h-3.5 w-3.5 shrink-0 text-zinc-500 transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-3">
          <div className="grid grid-cols-2 gap-x-3 gap-y-2">
            {rows.filter(Boolean).map(([label, value]) => (
              <div key={label} className="min-w-0">
                <p className="text-[9px] uppercase tracking-[0.12em] text-zinc-500">{label}</p>
                <div className="font-mono text-[11px] text-zinc-200 break-words">
                  {value ?? "—"}
                </div>
              </div>
            ))}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-1.5">{actions}</div>}
          {extra}
        </div>
      )}
    </div>
  );
};
